import { useEffect, useState } from 'react'
import { isTestingMode } from '#app/utils/test-mode.client.js'

/**
 * Renders a small fixed badge when testing mode is active so the tester
 * cannot forget their queries are logged as test traffic (`x-im-testing`,
 * see test-mode.client.ts). Hidden entirely when testing mode is off.
 */
export function TestModeIndicator() {
	const [active, setActive] = useState(false)

	useEffect(() => {
		setActive(isTestingMode())
	}, [])

	if (!active) return null

	return (
		<div
			role="status"
			aria-label="Test-läge aktivt"
			style={{
				position: 'fixed',
				top: 8,
				right: 8,
				zIndex: 9999,
				padding: '4px 10px',
				borderRadius: 6,
				background: 'rgba(180, 83, 9, 0.92)',
				color: '#fff',
				fontFamily:
					'-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
				fontSize: 11,
				fontWeight: 700,
				letterSpacing: '0.06em',
				textTransform: 'uppercase',
				boxShadow: '0 2px 6px rgba(0,0,0,0.18)',
				pointerEvents: 'none',
				userSelect: 'none',
			}}
		>
			Testläge
		</div>
	)
}
